<template>
  <div >
    <el-tabs class="tabs " v-model="activeName1" type="card" @tab-click="handleClick">
      <el-tab-pane label="个人资料" name="first" >
        <el-form :model="dataFrom" ref="dataForm" label-width="300px" class="demo-ruleForm" >
          <el-form-item prop="account" v-model="dataFrom.account" label="账号:" class="lab_icon lab">{{dataFrom.account}}</el-form-item>
          <!-- <el-form-item prop="sex" label="性别:" class="lab_icon">{{dataFrom.sex}} -->
            <!-- <el-radio v-model="dataFrom.sex" label="男">男</el-radio>
            <el-radio v-model="dataFrom.sex" label="女">女</el-radio> -->
          <!-- </el-form-item> -->
          <el-form-item prop="cardCode" label="身份证号码:" class="lab_icon lab">{{dataFrom.cardCode}}
            <!-- <el-input v-model="dataFrom.cardCode"></el-input> -->
          </el-form-item>
          <el-form-item prop="name" label="姓名:">
            <el-input v-model="dataFrom.name"></el-input>
          </el-form-item>
          <el-form-item prop="email" label="邮箱:">
            <el-input v-model="dataFrom.email"></el-input>
          </el-form-item>
          <el-form-item prop="contactor" label="联系人:">
            <el-input v-model="dataFrom.contactor"></el-input>
          </el-form-item>
          <el-form-item prop="phone" label="联系人电话:">
            <el-input v-model="dataFrom.phone"></el-input>
          </el-form-item>
          <!-- <el-form-item prop="birthday" label="出生日期:" class="lab_icon">{{dataFrom.birthday}} -->
            <!-- <el-date-picker type="date" v-model="dataFrom.birthday" placeholder style="width: 100%;"></el-date-picker> -->
          <!-- </el-form-item> -->
          <el-form-item class="submit">
            <el-button type="primary" @click="data2Form('dataForm')">提交</el-button>
          </el-form-item>
          <p class="txt">（注:*是必填项）</p>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="修改密码" name="second">
        <el-form
          :model="passwordForm"
          :rules="rulesPassword"
          ref="formData"
          label-width="300px"
          class="demo-ruleForm personFrom"
        >
          <el-form-item prop="oldPassword" label="原密码" class="lab_icon lab" >
            <el-input type="password" v-model="passwordForm.oldPassword"></el-input>
          </el-form-item>
          <el-form-item prop="newPassword" label="新密码" class="lab_icon lab" >
            <el-input type="password" v-model="passwordForm.newPassword"></el-input>
          </el-form-item>
          <el-form-item prop="checkPassword" label="确认密码" class="lab_icon lab" >
            <el-input type="password" v-model="passwordForm.checkPassword"></el-input>
          </el-form-item>
          <el-form-item class="submit">
            <el-button type="primary" @click="password2Form('formData')">提交修改</el-button>
          </el-form-item>
          <p class="txt">（注:*是必填项）</p>
        </el-form>
      </el-tab-pane>
      <!-- <el-tab-pane label="上传照片" name="third" class="load_cc">
        <div class="loadBox">
          <el-form>
            <p class="photoReq">照片请按尺寸上传（体积在1M以内）</p>
            <el-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-form-item class="submit">
              <el-button type="primary" @click="submitForm('ruleForm2')">提交修改</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      activeName1: "first",
    
      //个人资料
      dataFrom: {
        account:'',
        name:'',
        sex:'',
        cardCode:'',
        email:'',
        contactor:'',
        useId:'',
        phone:'',
        birthday:''
      },
      //修改密码
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        checkPassword: ""
      },
      rulesPassword: {
        oldPassword: [{required: true, message: '旧密码不能为空', trigger: 'blur'}],
        newPassword: [{required: true, message: '新密码不能为空', trigger: 'blur'}],
        checkPassword: [{ validator: validatePass2, trigger: "blur" }]
      },
      radio: "1",
      imageUrl: "",
      data: "",
      rules: {
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {
    console.log(localStorage.getItem("token"));
    this.dataList();
  },
  methods: {
    handleClick(tab, event) {
      this.typeId = event.index;
      if (event.index == 0) {
        this.typeId = null;
        console.log(this.typeId);
      }
    },
    dataList() {
      console.log(11);
      let me = this;
      let data = {
        pay: this.typeId
      };
      window.Global.get("/user/userInfo", data, rs => {
        console.log(rs.data.result);
        if (rs.data.success) {
          me.dataFrom = rs.data.result;
          this.dataFrom.useId = rs.data.result.id ;
          console.log(id)
        } else {
        }
      });
    },
    //个人资料
    data2Form(dataForm) {
      this.$refs[dataForm].validate((valid) => {
        console.log(1111111111111111111111111111)
        if (valid) {
          let self = this;
          let dataList ={
            id : this.dataFrom.useId,
            name : this.dataFrom.name,
            email:this.dataFrom.email,
            contactor:this.dataFrom.contactor,
            cardCode:this.dataFrom.cardCode,
          };
          window.Global.post("/user/updateInfo", dataList, rs => {
            console.log(rs.data.result);
            if (rs.status == 200) {
              self.$message.success(rs.data.message);
            } else {
              self.$message.error(rs.data.message);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //修改密码
    password2Form(formData) {
      this.$refs[formData].validate(valid => {
        console.log(22222222);
        if (valid) {
          let self = this;
          let passwordList = {
            oldPassword: this.$md5(this.passwordForm.oldPassword),
            newPassword: this.$md5(this.passwordForm.newPassword)
          };
          window.Global.post("/user/modifypswd", passwordList, rs => {
            console.log(rs.data.result);
            // self.$message.error(rs.data.message);
            if (rs.data.success) {
              self.$message.success(rs.data.message);
            } else {
              self.$message.error(rs.data.message);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less">
@import "../../static/less/dataDetail.less";
</style>


   


   


// WEBPACK FOOTER //
// src/components/DataDetail.vue